module.exports = __webpack_public_path__ + "static/img06__pc-030435a54e4b8a7ad88e4f8b1dc89280.svg";